import { DISABLED_COMMUNITY_EXPERIENCE_AVAILABILITY } from './communityExperienceAvailability';

export const LOCAL_DEVELOPMENT_COMMUNITY_EXPERIENCE_AVAILABILITY = Object.freeze({
  enabled: true,
  approvedLocales: Object.freeze(['en']),
  collectionNoticeVersion: 'community-experience-collection-notice-en@1',
  ageAttestationVersion: 'community-experience-age-attestation-en@1',
  publicationNoticeVersion: 'community-experience-publication-notice-en@1',
  publicSurface: 'all-voiced-public-website',
  authorizedUseKinds: Object.freeze(['public_website_display']),
});

// The frontend mirrors the backend's accepted English-only production
// boundary. The backend remains independently authoritative for every action.
export const PRODUCTION_ENGLISH_V1_COMMUNITY_EXPERIENCE_AVAILABILITY = Object.freeze({
  ...LOCAL_DEVELOPMENT_COMMUNITY_EXPERIENCE_AVAILABILITY,
});

const LOCAL_REVIEW_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);

export const resolveCommunityExperienceAvailability = ({
  nodeEnv = process.env.NODE_ENV,
  hostname = typeof window === 'undefined' ? '' : window.location.hostname,
} = {}) => {
  if (nodeEnv === 'development' && LOCAL_REVIEW_HOSTS.has(hostname)) {
    return LOCAL_DEVELOPMENT_COMMUNITY_EXPERIENCE_AVAILABILITY;
  }
  if (nodeEnv === 'production') {
    return PRODUCTION_ENGLISH_V1_COMMUNITY_EXPERIENCE_AVAILABILITY;
  }
  return DISABLED_COMMUNITY_EXPERIENCE_AVAILABILITY;
};
